import { useEffect } from "react";
import { AnalyticsService } from "./analytics";

const setMetaTag = (tagName: string, content: string) => {
	document.querySelector(`meta[name="${tagName}"]`)?.setAttribute("content", content);
}
const setLink = (rel: string, content: string) => {
	document.querySelector(`link[rel="${rel}"]`)?.setAttribute("href", content);
}

const useMetaTitle = (title: string) => {
	useEffect(() => {
		document.title = 'RusEtfs - ' + title;
	}, [title]);
}

const useMetaDescription = (description: string) => {
	useEffect(() => {
		setMetaTag('description', description);
	}, [description]);
}

const useMetaKeyWords = (keyWords: string[]) => {
	const effectiveKeyWords = keyWords.join(',');

	useEffect(() => {
		setMetaTag('keywords', effectiveKeyWords);
	}, [effectiveKeyWords]);
}

const useCanonical = (path: string ) => {
	useEffect(() => {
		setLink('canonical', 'https://rusetfs.com/' + path);
	}, [path]);
}

export interface PageMetaProps {
	title: string;
	description: string;
	keyWords: string[];
	canonicalPath: string
}

export const usePageMeta = (props: PageMetaProps) => {
	if (props.canonicalPath[0] == '/')
		throw 'canonical path should not start with `/`';
	
	const title = props.title 
		? props.title
		: 'RusEtfs';

	useMetaTitle(title);
	useMetaDescription(props.description);
	useMetaKeyWords(props.keyWords);
	useCanonical(props.canonicalPath);

	useEffect(() => {
		AnalyticsService.visit({
			title: title,
			visitUrl: '/' + props.canonicalPath,
			params: { }
		})
	}, [])
}